import { Button } from 'app/design/primitives/button';
import { useTranslation } from 'react-i18next';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconHelpCircle } from '@tabler/icons-react-native';
import { theme } from './theme';

export function ProfileHeaderHelp({ isLargeUI, onPress }: { isLargeUI: boolean; onPress: () => void }) {
  const { t } = useTranslation();
  return (
    <Button
      accessibilityLabel={t('place.helpButton', { ns: 'neighbour-profile' })}
      onPress={onPress}
      style={isLargeUI ? { marginRight: theme.spacing['spacing.general.x4'] } : {}}
      variant="plain"
    >
      <IconHelpCircle strokeWidth={ICON_STROKE_WIDTH} size={30} color={theme.colors['text.primary']} />
    </Button>
  );
}
